import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal, Signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MatDialog,
  MatDialogClose,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { ItemType } from '../../types/item-type.type';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { ServiceCardsService } from '../../services/service-cards.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-modal-service-card',
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatChipsModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  templateUrl: './modal-service-card.component.html',
  styleUrl: './modal-service-card.component.css'
})
export class ModalServiceCardComponent implements OnInit {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ModalServiceCardComponent> = inject(MatDialogRef);

  public itemsType: Signal<ItemType[]> = signal([
    { value: 1, name: "Karta serwisowa" },
  ]);

  public activity: Signal<ItemType[]> = signal([
    { value: 0, name: "Nieaktywna" },
    { value: 1, name: "Aktywna" }
  ]);

  public editForm: FormGroup = new FormGroup({
    id: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    type: new FormControl("1", [Validators.required]),
    uuid: new FormControl("", [Validators.required]),
    pin: new FormControl("", [Validators.required, Validators.minLength(4), Validators.maxLength(6)]),
    active: new FormControl(0, [Validators.required])
  });



  constructor(
    public notificationService: NotificationService,
    public serviceCardsService: ServiceCardsService,
    public router: Router
  ) {

  }

  ngOnInit(): void {

    console.log("UUID", crypto.randomUUID())
    this.editForm.controls['uuid'].setValue(crypto.randomUUID())
    let currentCard = this.serviceCardsService.getCurrentCard();

    this.editForm.setValue({
      id: currentCard.id,
      description: currentCard.description,
      type: currentCard.type,
      uuid: currentCard.uuid,
      pin: currentCard.pin,
      active: currentCard.active
    });

    this.editForm.controls['uuid'].disable();


  }

  onSubmit() {
    console.log("submit")
    const card = {
      id: this.editForm.value.id,
      description: this.editForm.value.description,
      type: this.editForm.value.type,
      //uuid: this.editForm.value.uuid,
      uuid: this.editForm.get('uuid')?.getRawValue(),
      pin: this.editForm.value.pin,
      active: this.editForm.value.active
    }
    if (card.id === 0) {
      this.serviceCardsService.addCard(card)
        .subscribe({
          next: (response: any) => {
            this.notificationService.pushNotification('Dodano kartę', 'info');
            this.dialogRef?.close();
          },
          error: (error: any) => {
            this.notificationService.pushNotification('Błąd podczas dodawania karty', 'error');
          }
        });
    } else {
      this.serviceCardsService.updateCard(card)
        .subscribe({
          next: (response: any) => {
            this.notificationService.pushNotification('Zaktualizowano kartę', 'info');
            this.dialogRef?.close();
          },
          error: (error: any) => {
            this.notificationService.pushNotification('Błąd podczas aktualizacji karty', 'error');
          }
        });
    }
    
  }

  getTitle() {
    if(this.editForm.value.id === '' || this.editForm.value.id === null || this.editForm.value.id === undefined || this.editForm.value.id === 0) {
      return "Dodaj kartę"
    } else {
      return "Edytuj kartę"
    }
    
  }

  getSaveText() {
    if(this.editForm.value.id === '' || this.editForm.value.id === null || this.editForm.value.id === undefined || this.editForm.value.id === 0) {
      return "Dodaj"
    } else {
      return "Zapisz"
    }
  }

  checkDisabled() {
    if(this.editForm.invalid) {
      return true
    }
    return false
  }

  onSelectionChange(event: any) {
    console.log(event)
  }

}
